import { css } from 'styled-components';
import {
  colors,
  duration,
  ease,
  elevation,
  isDefaultThemeMode
} from 'core/theme';
import { CardBase } from './';


const applyBoxShadow = (props) => {
  if (isDefaultThemeMode(props)) {
    return css`
      box-shadow: ${elevation.Z2};
      transition: box-shadow ${duration.fast} ${ease.standard};
      will-change: box-shadow;

      &:hover {
        box-shadow: ${elevation.Z8};
      }
    `;
  }
};

const applyThumbScale = (props) => {
  return css`
    & *[data-thumb] {
      transform: scale(1.0);
      transition: transform ${duration.normal} ${ease.standard};
      will-change: transform;
    }

    &:hover *[data-thumb] {
      transform: scale(1.05);
    }
  `;
}

const StyledCard = CardBase.extend`
  background-color: ${colors.background};
  @media screen {
    ${applyBoxShadow};
    ${applyThumbScale};
  }
`;

export default StyledCard;



// WEBPACK FOOTER //
// ./src/elements/Card/styled/StyledCard.js